import React from 'react';

interface ContractorInlineHelpShortcutProps {
  onNavigate: (screen: string) => void;
  sectionId?: string;
  label?: string;
  originScreen?: string;
}

export default function ContractorInlineHelpShortcut({
  onNavigate,
  sectionId = 'reviewing-jobs',
  label = 'Need help on this screen?',
  originScreen = 'contractor-dashboard',
}: ContractorInlineHelpShortcutProps) {
  return (
    <div
      style={{
        margin: '10px 0 14px 0',
        border: '1px solid #bfdbfe',
        borderRadius: 10,
        background: '#eff6ff',
        padding: '10px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <div style={{ color: '#1e3a8a', fontSize: 14 }}>{label}</div>
      <button
        className="btn btn-secondary"
        onClick={() => {
          try {
            sessionStorage.setItem('cb.contractor.help.section', sectionId);
            sessionStorage.setItem('cb.help.origin', originScreen);
          } catch {}
          onNavigate('contractor-help');
        }}
      >
        Open Help
      </button>
    </div>
  );
}

